module.exports = __webpack_public_path__ + "img/ch63.f06df7d1.jpg";